import React from 'react';
import { connect } from 'react-redux';
import { Box, Link } from '@nerdwallet/currency';

import classNames from 'classnames';

import styles from './wp-edit-link.module.less';
import { ReduxStore } from '~/lib/types';

const createStandardEditLinkUrl = (id: string) => {
  return `/blog/wp-admin/post.php?post=${id}&action=edit`;
};

interface Props {
  hasWpCookie: boolean;
  identifier: string;
  text?: string;
  useCustomStyle?: boolean;
}

const WpEditLink: React.FC<Props> = ({
  hasWpCookie,
  identifier,
  text = 'Edit Article',
  useCustomStyle = false,
}) => {
  if (!(hasWpCookie && identifier)) {
    return null;
  }

  const url = identifier.startsWith('http')
    ? identifier
    : createStandardEditLinkUrl(identifier);

  return (
    <Box className={classNames(useCustomStyle && styles['wp-edit-link'])}>
      <Link href={url} target="new">
        {text}
      </Link>
    </Box>
  );
};

const mapStateToProps = (state: ReduxStore) => ({
  hasWpCookie: state.hasWpCookie,
});

export default connect(mapStateToProps, null)(WpEditLink);
